let utils = {
  methods: {
    addParamsToLocation (params) {
      history.pushState(
        {},
        null,
        this.$route.path +
        '?' +
        Object.keys(params)
          .map(key => {
            return (
              encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
            )
          })
          .join('&')
      )
    },
    formatText (text) {
      return text.toLowerCase().replace('_', ' ')
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ')
    },
    formatMoney (amount) {
      let currency = this.$store.state.metas.currency.meta_value

      if (this.$store.state.vendors) {
        if (this.$store.state.vendors[this.$store.state.currentVendor].currency !== null) {
          currency = this.$store.state.vendors[this.$store.state.currentVendor].currency
        }
      }

      if (currency === null || currency.length < 2) {
        currency = 'USD'
      }

      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency
      }).format(amount)
    },
    isEmpty (e) {
      switch (e) {
        case '':
        case 0:
        case null:
        case false:
        case typeof this === 'undefined':
          return true
        default:
          return false
      }
    }
  }
}

export default utils



// WEBPACK FOOTER //
// ./src/mixins/utils.js